import { normalizeCountryCode } from '@shared/utils'
import { queryOptions } from '@tanstack/react-query'

import type { HomeBannerPlacement } from '../model'
import { getHomeBanners } from './home-banners.api'

type HomeBannerQueryOptions = RequestQueryOptionalOptions<{
  countryCode?: string | null
  placement?: HomeBannerPlacement
}>

export const homeBannersEntityQueries = {
  all: ['home-banners'],

  getHomeBannersQueryKey: ({ bearerToken, countryCode, placement = 'HOME' }: HomeBannerQueryOptions) => [
    ...homeBannersEntityQueries.all,
    'home-banners',
    placement,
    bearerToken,
    normalizeCountryCode(countryCode),
  ],

  getHomeBanners: ({ bearerToken, countryCode, placement = 'HOME' }: HomeBannerQueryOptions) =>
    queryOptions({
      queryKey: homeBannersEntityQueries.getHomeBannersQueryKey({ bearerToken, countryCode, placement }),
      queryFn: async () => await getHomeBanners({ bearerToken, countryCode, placement }),
      enabled: placement !== 'HOME' || Boolean(bearerToken),
      retry: false,
    }),
} as const
